import { render, staticRenderFns } from "./counsel-card.vue?vue&type=template&id=5e10201f&"
import script from "./counsel-card.vue?vue&type=script&lang=js&"
export * from "./counsel-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports